export default __webpack_public_path__ + "static/media/job-title.0f2db293.svg";